<template>
<svg data-svg-lvl-3="spread-block-shadow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs><mask id="lsh-m" x="28.4102" y="51" width="452.6442" height="336" maskUnits="userSpaceOnUse"><path class="lsh-c-2" d="M256.693,73.5646H28.4102v283.3129h419.9396V73.5646h-191.6567Z"/></mask></defs><g id="Тень_Блока"><g class="lsh-c-5"><g class="lsh-c-1"><image width="449" height="336" transform="translate(32.0544 51)" :href="`${$CONST.cnstrAssetsUrl}/preview-layers/spread/block/shadow/RH35_1.webp`"/></g></g></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.lsh-c-1{opacity:.4;}.lsh-c-2{fill:#fff;}.lsh-c-2,.lsh-c-3{stroke-width:0px;}.lsh-c-4{opacity:.3;}.lsh-c-5{mask:url(#lsh-m);}.lsh-c-3{fill:#64ff00;}</style>

